<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
 <el-form-item label="项目名称" >
  <el-cascader
    v-model="value"
    :options="osData"
    @change="handleChange"
    :props="{ checkStrictly: true }"
    :show-all-levels="false"
    :emitPath="false"
    size="small"
    ></el-cascader>
      </el-form-item>
  <el-form-item label="楼宇类型" >
    <el-select  clearable v-model="valueone" placeholder="请选择楼宇类型"  size="small" @change="TenementType" >
        <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="楼宇代码">
    <el-input v-model="formLabelAlign.floorCode" size="small"></el-input>
  </el-form-item>
  <el-form-item label="楼宇名称">
    <el-input v-model="formLabelAlign.floorName" size="small"></el-input>
  </el-form-item>
    <el-form-item label="楼高" >
      <el-input v-model="formLabelAlign.floorHeight" size="small"></el-input>
    </el-form-item>
    <el-form-item label="层数" >
     <el-input v-model="formLabelAlign.divNum" size="small"></el-input>
    </el-form-item>
        <el-form-item label="楼宇结构" >
     <el-input v-model="formLabelAlign.floorStruct" size="small"></el-input>
    </el-form-item>
        <el-form-item label="用途" >
     <el-input v-model="formLabelAlign.purpose" size="small"></el-input>
    </el-form-item>
        <el-form-item label="建筑面积" >
     <el-input v-model="formLabelAlign.buildArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="使用面积" >
     <el-input v-model="formLabelAlign.usageArea" size="small"></el-input>
    </el-form-item>
      <el-form-item label="开工日期" >
      <el-date-picker
      v-model="openDate"
      type="date"
      placeholder="选择日期"
      @change="openDateL()">
    </el-date-picker>
    </el-form-item>
        <el-form-item label="竣工日期" >
     <el-date-picker
      v-model="finishDate"
      type="date"
      placeholder="选择日期"
      @change="finishDateL()">
    </el-date-picker>
    </el-form-item>
            <el-form-item label="排序号" >
     <el-input v-model="formLabelAlign.orderNum" size="small"></el-input>
    </el-form-item>
        <el-form-item label="备注信息" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BuildingDialog",
  data() {
    return {
    osData:[],
     value: [],
     optionsone: [{valueone: '1',labelone: '高层'}, {valueone: '2',labelone: '多层'},{valueone: '4',labelone: '小高层'}],
        value: '',
        valueone: '',
     dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",


     projectId:"",
     floorType:"",
     openDate:"",
     openDateTime:"",
     finishDateTime:"",
     finishDate:"",
     projectCode:"",
     projectS:"",
    };
  },
  watch:{
      dialogVisible(val){
      if(val == true){
        if(this.title == "添加"){
          this.formLabelAlign = {}
          this.valueone = ""
          this.value = ""
          this.finishDate = ""
          this.openDate = ""
        }else{
          for(let val of this.osData){
            if(val.label == this.projectS){
              this.value = val.value
            }
          }
          let startDate = this.formLabelAlign.startDate.replace('T',' ')
          this.openDate = startDate.substr(0,startDate.length-9)
          let finishDate = this.formLabelAlign.finishDate.replace('T',' ')
          this.finishDate = finishDate.substr(0,finishDate.length-9)
        }
    }
  }
  },
  methods: {
      handleChange(value){
           this.projectId = value[0]
      },
      TenementType(valueone){
          this.floorType = valueone
      },
    modification(){

        if(this.title == "修改"){
             let obj = {
                  "id":this.formLabelAlign.floorId,
                  "projectId": this.projectId,
                  "projectCode": this.projectCode,
                  "floorType": this.floorType,
                  "floorCode": this.formLabelAlign.floorCode,
                  "floorName": this.formLabelAlign.floorName,
                  "floorProperty": "",
                  "floorHeight": this.formLabelAlign.floorHeight,
                  "divNum": this.formLabelAlign.divNum,
                  "floorStruct": this.formLabelAlign.floorStruct,
                  "purpose": this.formLabelAlign.purpose,
                  "buildArea": this.formLabelAlign.buildArea,
                  "usageArea": this.formLabelAlign.usageArea,
                  "startDate": this.openDateTime,
                  "finishDate": this.finishDateTime,
                  "orderNum": this.formLabelAlign.orderNum,
                  "remarks": this.formLabelAlign.remarks,
                  "mangerName": "",
                  "mangerId": ""
                }
            if(obj.projectId != undefined || obj.projectId != null || obj.projectId != "" ){
              if(obj.floorCode != undefined || obj.floorCode != null || obj.floorCode != "" ){
                 if(obj.floorName != undefined || obj.floorName != null || obj.floorName != "" ){
             this.$http.put(this.$requestUrl.PUT_BUILDING_AMEND,obj).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$message({
            type: 'success',
            message: '修改成功!'
          });
                this.$emit("Visible",false)
              } else if(result.code == 500) {
                 this.$message({
                    message: result.msg,
                    type: 'warning'
                  });
              }else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
              }else{
                 this.$message({
                    message: '请选择楼宇名称！',
                    type: 'warning'
                  });
              }
              }else{
                 this.$message({
                    message: '请填写楼宇代码！',
                    type: 'warning'
                  });
              }
            }else{
               this.$message({
                    message: '请选择归属机构！',
                    type: 'warning'
                  });
            }
        }else if(this.title == "添加"){

              let obj = {
                  "projectId": this.projectId,
                  "projectCode": this.projectCode,
                  "floorType": this.floorType,
                  "floorCode": this.formLabelAlign.floorCode,
                  "floorName": this.formLabelAlign.floorName,
                  "floorProperty": "",
                  "floorHeight": this.formLabelAlign.floorHeight,
                  "divNum": this.formLabelAlign.divNum,
                  "floorStruct": this.formLabelAlign.floorStruct,
                  "purpose": this.formLabelAlign.purpose,
                  "buildArea": this.formLabelAlign.buildArea,
                  "usageArea": this.formLabelAlign.usageArea,
                  "startDate": this.openDateTime,
                  "finishDate": this.finishDateTime,
                  "orderNum": this.formLabelAlign.orderNum,
                  "remarks": this.formLabelAlign.remarks,
                  "mangerName": "",
                  "mangerId": ""
                }
                // console.log(obj)
            if(obj.projectId != undefined || obj.projectId != null || obj.projectId != "" ){
              if(obj.floorCode != undefined || obj.floorCode != null || obj.floorCode != "" ){
                 if(obj.floorName != undefined || obj.floorName != null || obj.floorName != "" ){
            this.$http.post(this.$requestUrl.POST_BUILDING_ADD,obj).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("Visible",false)
                 this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
              } else if(result.code == 500) {
                 this.$message({
                    message: result.msg,
                    type: 'warning'
                  });
              }else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
              }else{
                 this.$message({
                    message: '请选择楼宇名称！',
                    type: 'warning'
                  });
              }
              }else{
                 this.$message({
                    message: '请填写楼宇代码！',
                    type: 'warning'
                  });
              }
            }else{
               this.$message({
                    message: '请选择归属机构！',
                    type: 'warning'
                  });
            }

        }

    },
    getMsgFormSon(data){
        this.options = data
    },
     openDateL(){
      let date = this.openDate;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let time = year+"-"+month+"-"+dates
            this.openDateTime = time
    },
    finishDateL(){
      let date = this.finishDate;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            // let time = year+"-"+month+"-"+dates
            let time = year+"-"+month+"-"+dates
            this.finishDateTime = time
    },
        getUserOffice() {
      this.$http.get(this.$requestUrl.GET_PROJECT_TREE).then((res) => {
        let data = res.data;
        let arr =[]
        if (200 === data.code) {
            for(let val of data.data){
                 var parent = {//转换成el-Cascader可以识别的数据结构
                    'label': val.projectName,
                    'value':val.projectId,
                }
                arr.push(parent)
            }
              // this.$emit('AllData',arr)
             this.osData = arr
             this.loading=false
        } else {
          this.$message.error(data.msg)
          this.loading=false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading=false
      })
    },
    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
       if(this.formLabelAlign.obj == undefined){
             let obj = {
            "areaname":"项目名称",
            "orgCode":"楼宇类型",
            "code":"楼宇代码",
            "name":"楼宇名称",
            "site":"楼高",
            "floor":"层数",
            "buildArea":"楼宇结构",
            "public":"用途",
            "afforest":"建站面积",
            "way":"使用面积",
            "start":"开工日期",
            "userType":"竣工日期",
            "groundarea":"排序号",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
  mounted(){
    this.getUserOffice()
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>
<style>
.el-cascader-node__label{
  color: black;
}
</style>